import cln from 'classnames'
import React from 'react'

type Props = {
  isOverflowing: boolean
  descrRef: React.RefObject<HTMLParagraphElement>
  description: string | undefined
  isExpanded: boolean
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>
}
export function InfoWindowExpandedSection(props: Props) {
  const { isOverflowing, descrRef, description, isExpanded, setIsExpanded } = props
  const toggleExpand = () => setIsExpanded((prev) => !prev)

  if (description === undefined || description?.trim() === '') return null

  return (
    <div className="description-wrap">
      <p className={`object__description ${isExpanded ? 'opened' : 'closed'}`} ref={descrRef}>
        {description}
      </p>

      {isOverflowing && (
        <div
          className={cln(
            'expanded__button__background',
            isExpanded && 'expanded__button__background__expanded',
          )}
        >
          <button onClick={toggleExpand} className={'expanded__button'}>
            Show {isExpanded ? 'less' : 'more'}
            <svg
              style={{ transform: `rotate(${isExpanded ? '180deg' : '0'})` }}
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="5"
              viewBox="0 0 8 5"
              fill="none"
            >
              <path d="M8 5L4.76837e-07 5L4 -1.27146e-07L8 5Z" fill="#05D5B3" />
            </svg>
          </button>
        </div>
      )}
    </div>
  )
}
